import * as Yup from 'yup'
export const validationSchema = Yup.object().shape({
    purchase_price:Yup.string().required('Purchase price is required !'),
    quantity:Yup.number().required('Qunatity is required !')      
  })